

<div class="container">
    <slot></slot>
</div>

<style>
    .container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        min-height: 200px;
        width: 100%;
        row-gap: 10px;
    }
</style>